// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f70ac234","879":"8397d01b"}[chunkId] + ".chunk.js";
};